/* dashboard-rediseno (15-oct-2026): EL PANEL FLOTANTE DEBAJO DE LA TARJETA.

   ARCHIVO EN ASCII A PROPOSITO (regla de la casa para los `.js` nuevos).

   Componente nuevo "Panel flotante" del documento: fondo #1B1B1B, borde #2C2C2C, radio 14 a
   16 y sombra; sale debajo de la tarjeta (no dentro: la tarjeta no puede cambiar de alto,
   regla 4) y se cierra al tocar fuera, al tocar otra vez su boton y con Esc, uno a la vez.
   Lo usan el boton de informacion del escaneado (A4), el motivo de falla cortado (A6 y A7) y
   las figuras (A14).

   `boton(props)` pinta el boton que lo abre con las props que le pasa esta pieza (ref, clic,
   `aria-expanded`); `contenido()` pinta lo de adentro. El estado abierto es de CADA instancia:
   la gemela del telefono y la de escritorio tienen el suyo, y asi una gemela escondida nunca le
   cierra el panel a la que se ve. La caja se ancla al primer ancestro posicionado, que es la
   tarjeta. `alAbrir` corre al abrir (por ejemplo, para pedir las figuras). */
import React, { useCallback, useRef, useState } from 'react';
import { useCierreDeFlotante } from './unoALaVez';

export const CAJA_FLOTANTE = 'absolute left-0 right-0 top-full mt-2 z-40 rounded-[14px] border border-[#2C2C2C] bg-[#1B1B1B] p-3.5 shadow-xl cursor-default';

export default function Flotante({ boton, contenido, alAbrir, testid, className = '' }) {
  const [abierto, setAbierto] = useState(false);
  const cajaRef = useRef(null);
  const botonRef = useRef(null);
  const cerrar = useCallback(() => setAbierto(false), []);
  useCierreDeFlotante(abierto, cerrar, cajaRef, botonRef);
  const alternar = (e) => {
    if (e) e.stopPropagation();
    if (abierto) { setAbierto(false); return; }
    setAbierto(true);
    // Si lo que se pide al abrir falla (devuelve false), el panel se vuelve a cerrar.
    const r = alAbrir ? alAbrir() : null;
    if (r && typeof r.then === 'function') r.then((bien) => { if (bien === false) setAbierto(false); }).catch(() => {});
  };
  return (
    <>
      {boton({ ref: botonRef, onClick: alternar, 'aria-expanded': abierto })}
      {abierto ? (
        <div ref={cajaRef} className={`${CAJA_FLOTANTE} ${className}`} onClick={(e) => e.stopPropagation()} data-testid={testid}>
          {contenido()}
        </div>
      ) : null}
    </>
  );
}
